import type { Collector } from "./types";
import { isBrowser } from "./types";

export const canvasCollector: Collector<{ hash?: string }> = {
  name: "canvas",
  version: 1,
  timeoutMs: 1000,
  collect() {
    return { hash: canvasHash() };
  },
};

function canvasHash(): string | undefined {
  if (!isBrowser) return undefined;
  try {
    const c = document.createElement("canvas");
    c.width = 200;
    c.height = 50;
    const g = c.getContext("2d")!;
    g.textBaseline = "top";
    g.font = "16px 'Arial'";
    g.fillStyle = "#f60";
    g.fillRect(0, 0, 200, 50);
    g.fillStyle = "#069";
    g.fillText("fp-canvas-probe", 2, 2);
    const d = g.getImageData(0, 0, 200, 50).data;
    let h = 0;
    for (let i = 0; i < d.length; i += 10) h = (h * 31 + d[i]) >>> 0;
    return h.toString(16);
  } catch {
    return undefined;
  }
}
